const cards = document.querySelectorAll('.j-project-card');
const btns = document.querySelectorAll('.j-project-btn');
const breakpoint = window.matchMedia('(min-width:1024px)');

const breakpointChecker = () => {
    if (breakpoint.matches) {
        cards.forEach((card) => {
            card.addEventListener('mouseover', () => {
                card.classList.add('is-active');
                card.addEventListener('mouseleave', () => {
                    card.classList.remove('is-active');
                });
            });
        });
    } else {
        btns.forEach((button) => {
            button.addEventListener('click', () => {
                const card = button.closest('.j-project-card');

                if (card.classList.contains('is-active')) {
                    card.classList.remove('is-active');
                } else {
                    card.classList.add('is-active');
                }
            });
        });
    }
};

const animateProjectCard = () => {
    if (!cards) {
        return;
    }

    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
};

export {animateProjectCard};
